import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Unauthorized } from '@ad-scripts/application/lib/error';

import { Auth, AuthUtils } from 'src/models/Auth';
import * as sharedTypes from 'src/actions/shared/sharedTypes';

const initialState: Auth = {};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action: PayloadAction<Auth>) {
      return action.payload;
    },
    logout() {
      return {};
    },
    tokenRefresh(state, action: PayloadAction<Auth>) {
      return action.payload;
    },
  },
});

const { login, logout, tokenRefresh } = authSlice.actions;

export const refreshToken: sharedTypes.AppThunk =
  () =>
  async (dispatch, getState, { gateways }) => {
    try {
      if (AuthUtils.isLoggedIn(getState().auth)) {
        const result = await gateways.auth.tokenRefresh();
        dispatch(tokenRefresh(result));
      }
    } catch (err) {
      if (err instanceof Unauthorized) {
        dispatch(logout());
      }
    }
  };

export { login, logout, tokenRefresh };
export default authSlice;
